import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-more-like-this',
    templateUrl: './more-like-this.component.html',
    styleUrls: ['./more-like-this.component.scss'],
    standalone: true,
    imports: [
        ButtonComponent,
        CommonModule
    ]
})
export class MoreLikeThisComponent {

    @Input() title: string;
    @Input() links: any;
    @Input() entityTypeUrl: string;

    constructor() { }

}
